module.exports = __webpack_public_path__ + "img/激动.f265b6b5.gif";